import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

const getTodayDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const DriverStatusModal = ({
  show,
  onHide,
  selectedrow,
  targetStatus,
  updatedBy,
  updatedById,
  onConfirm,
}) => {
  const [formInputs, setFormInputs] = useState({
    statusDate: getTodayDate(),
    statusRemark: "",
  });

  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setFormInputs({
        statusDate: getTodayDate(),
        statusRemark: "",
      });
      setErrorMsg("");
    }
  }, [show]);

  const resetForm = () => {
    setFormInputs({
      statusDate: getTodayDate(),
      statusRemark: "",
    });
    setErrorMsg("");
  };

  const handleSubmit = async () => {
    if (!formInputs.statusDate) {
      setErrorMsg("*Please select date");
      return;
    }

    if (!formInputs.statusRemark.trim()) {
      setErrorMsg("*Please enter remarks");
      return;
    }

    if (!selectedrow?.userId) {
      setErrorMsg("*Driver details not found");
      return;
    }

    const payload = {
      userId: selectedrow.userId,
      activeInactive: targetStatus,

      // Maintain separate Active and Inactive dates
      activeDate: targetStatus
        ? formInputs.statusDate
        : selectedrow.activeDate || null,

      inactiveDate: !targetStatus
        ? formInputs.statusDate
        : selectedrow.inactiveDate || null,

      statusRemark: formInputs.statusRemark.trim(),

      updatedBy: updatedBy,
      updatedById: updatedById,
    };

    try {
      setLoading(true);

      const response = await onConfirm(payload);

      if (response?.status === 200) {
        resetForm();
        onHide();
      }
    } catch (error) {
      console.error("Driver status update:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" keyboard={false}>
      <Modal.Header
        style={{
          backgroundColor: "#88B6F2",
          color: "#fff",
          borderBottom: "none",
        }}
      >
        <Modal.Title>
          <i className="bi bi-person-check me-2"></i>
          Update Driver Status
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "25px 30px" }}>
        <Row>
          <Col xs={12}>
            <p style={{ fontSize: "16px", fontWeight: 500 }}>
              Do you want to change the status of this driver?
            </p>

            <div className="mb-3">
              <label className="form-label fw-bold">Driver</label>
              <input
                className="form-control"
                value={selectedrow?.employeeName || ""}
                disabled
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Driver ID</label>
              <input
                className="form-control"
                value={selectedrow?.userId || ""}
                disabled
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">New Status</label>

              <input
                className="form-control"
                value={targetStatus ? "Active" : "Inactive"}
                disabled
                style={{
                  fontWeight: "bold",
                  color: targetStatus ? "#198754" : "#dc3545",
                }}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">
                {targetStatus ? "Active Date" : "Inactive Date"}
                <span className="text-danger">*</span>
              </label>

              <input
                type="date"
                className="form-control"
                value={formInputs.statusDate}
                onChange={(e) =>
                  setFormInputs((prev) => ({
                    ...prev,
                    statusDate: e.target.value,
                  }))
                }
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">
                Remarks <span className="text-danger">*</span>
              </label>

              <textarea
                className="form-control"
                rows={3}
                placeholder="Enter status change remarks"
                value={formInputs.statusRemark}
                onChange={(e) =>
                  setFormInputs((prev) => ({
                    ...prev,
                    statusRemark: e.target.value,
                  }))
                }
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Updated By</label>

              <input
                className="form-control"
                value={updatedBy || ""}
                disabled
              />
            </div>

            {errorMsg && <p className="text-danger mt-2">{errorMsg}</p>}
          </Col>
        </Row>

        <Row className="d-flex justify-content-end gap-2 mt-3">
          <Col xs="auto">
            <button
              type="button"
              onClick={() => {
                resetForm();
                onHide();
              }}
              disabled={loading}
              className="btn btn-danger"
            >
              Cancel
            </button>
          </Col>

          <Col xs="auto">
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="btn btn-primary"
            >
              {loading ? "Updating..." : "Confirm"}
            </button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default DriverStatusModal;
